import React from "react";
import "./Home.css";
import bighead from "./bighead.png";

function Home() {
  let openghClicked = () => {
    const url = "https://github.com/shinyiho";
    window.open(url, "_blank");
  };
  let openliClicked = () => {
    const url = "https://www.linkedin.com/in/shinyi-ho-13871b73/";
    window.open(url, "_blank");
  };
  return (
    <div className="home">
      <div className="profile">
        <img alt="my big head" src={bighead}></img>
        <p>
          Hi! This is Shin, a former IC design engineer, now a software engineer. Previously working for Himax
          Technologies as a system engineer and United Microelectronics Corporation as a process engineering integration
          intern. I received my M.S. degree in EE at National Taiwan University. I love using technology to make things
          happen and feel most fulfilled when using my skills to do so.
        </p>
      </div>
      <footer>
        2021 @ ShinyiHo
        <img
          onClick={openliClicked}
          src="https://img.icons8.com/ios-filled/50/000000/linkedin.png"
          alt="linkedinicon"
        />
        <img
          onClick={openghClicked}
          src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEwMjQiIHdpZHRoPSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik01MTIgMEMyMjkuMjUgMCAwIDIyOS4yNSAwIDUxMmMwIDIyNi4yNSAxNDYuNjg4IDQxOC4xMjUgMzUwLjE1NiA0ODUuODEyIDI1LjU5NCA0LjY4OCAzNC45MzgtMTEuMTI1IDM0LjkzOC0yNC42MjUgMC0xMi4xODgtMC40NjktNTIuNTYyLTAuNzE5LTk1LjMxMkMyNDIgOTA4LjgxMiAyMTEuOTA2IDgxNy41IDIxMS45MDYgODE3LjVjLTIzLjMxMi01OS4xMjUtNTYuODQ0LTc0Ljg3NS01Ni44NDQtNzQuODc1LTQ2LjUzMS0zMS43NSAzLjUzLTMxLjEyNSAzLjUzLTMxLjEyNSA1MS40MDYgMy41NjIgNzguNDcgNTIuNzUgNzguNDcgNTIuNzUgNDUuNjg4IDc4LjI1IDExOS44NzUgNTUuNjI1IDE0OSA0Mi41IDQuNjU0LTMzIDE3LjkwNC01NS42MjUgMzIuNS02OC4zNzVDMzA0LjkwNiA3MjUuNDM4IDE4NS4zNDQgNjgxLjUgMTg1LjM0NCA0ODUuMzEyYzAtNTUuOTM4IDE5Ljk2OS0xMDEuNTYyIDUyLjY1Ni0xMzcuNDA2LTUuMjE5LTEzLTIyLjg0NC02NS4wOTQgNS4wNjItMTM1LjU2MiAwIDAgNDIuOTM4LTEzLjc1IDE0MC44MTIgNTIuNSA0MC44MTItMTEuNDA2IDg0LjU5NC0xNy4wMzEgMTI4LjEyNS0xNy4yMTkgNDMuNSAwLjE4OCA4Ny4zMTIgNS44NzUgMTI4LjE4OCAxNy4yODEgOTcuNjg4LTY2LjMxMiAxNDAuNjg4LTUyLjUgMTQwLjY4OC01Mi41IDI4IDcwLjUzMSAxMC4zNzUgMTIyLjU2MiA1LjEyNSAxMzUuNSAzMi44MTIgMzUuODQ0IDUyLjYyNSA4MS40NjkgNTIuNjI1IDEzNy40MDYgMCAxOTYuNjg4LTExOS43NSAyNDAtMjMzLjgxMiAyNTIuNjg4IDE4LjQzOCAxNS44NzUgMzQuNzUgNDcgMzQuNzUgOTQuNzUgMCA2OC40MzgtMC42ODggMTIzLjYyNS0wLjY4OCAxNDAuNSAwIDEzLjYyNSA5LjMxMiAyOS41NjIgMzUuMjUgMjQuNTYyQzg3Ny40MzggOTMwIDEwMjQgNzM4LjEyNSAxMDI0IDUxMiAxMDI0IDIyOS4yNSA3OTQuNzUgMCA1MTIgMHoiIC8+Cjwvc3ZnPgo="
          alt="ghicon"
        ></img>
      </footer>
    </div>
  );
}

export default Home;
